import { put, takeLatest, all } from "redux-saga/effects";
import { GET_CONSTANTS } from "../constants/serverConstants";
import { getConstantsSuccess } from "../actions/serverConstants";

import { getServerConstants } from "../../apiCalls/serverConstants";

function* getConstants(action) {
  try {
    const response = yield getServerConstants();
    if (response.data.statusCode === 200) {
      let result = response.data.data;

      yield put(getConstantsSuccess(result));
    }
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      //console.log(error);
    }
  }
}

export default function* authSaga() {
  yield all([takeLatest(GET_CONSTANTS, getConstants)]);
}
